"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInviteCtrl = exports.InviteMethod = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var index_1 = require("../../i18n/index");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var InviteMethod;
(function (InviteMethod) {
    InviteMethod["LoggedIn"] = "current";
    InviteMethod["Login"] = "login";
    InviteMethod["Signup"] = "signup";
    InviteMethod["Undecided"] = "choose";
    InviteMethod["Success"] = "done";
    InviteMethod["SuccessSSO"] = "accountCreated";
    InviteMethod["FailedSSO"] = "accountError";
})(InviteMethod || (exports.InviteMethod = InviteMethod = {}));
var AcceptInviteCtrl = /** @class */ (function () {
    function AcceptInviteCtrl(inviteToken) {
        this.awaitingCheck = false;
        this.loading = true;
        this.validatedToken = false;
        this.authFailed = false;
        this.inviteMethod = InviteMethod.Undecided;
        this.inviteToken = inviteToken;
    }
    AcceptInviteCtrl.prototype.setValidEmail = function (isValid) {
        this.validEmail = isValid;
    };
    AcceptInviteCtrl.prototype.handleError = function () {
        this.setLoading(false);
        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
    };
    AcceptInviteCtrl.prototype.validateInviteToken = function () {
        var _this = this;
        this.setLoading(true);
        return services_1.Services.Department.Invite.verify(this.inviteToken)
            .then(function (valid) {
            _this.setTokenValidity(valid);
            if (valid && services_1.Services.User.hasUser) {
                _this.setInviteMethod(InviteMethod.LoggedIn);
            }
            _this.setLoading(false);
        })
            .catch(function () { return _this.handleError(); });
    };
    AcceptInviteCtrl.prototype.setInviteMethod = function (inviteMethod) {
        if (inviteMethod === InviteMethod.LoggedIn && !this.hasUser) {
            this.inviteMethod = InviteMethod.Undecided;
        }
        else {
            this.inviteMethod = inviteMethod;
        }
    };
    Object.defineProperty(AcceptInviteCtrl.prototype, "user", {
        get: function () {
            return services_1.Services.User.current;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AcceptInviteCtrl.prototype, "hasUser", {
        get: function () {
            return services_1.Services.User.hasUser;
        },
        enumerable: false,
        configurable: true
    });
    AcceptInviteCtrl.prototype.inviteLoggedInUser = function () {
        var _this = this;
        if (!this.hasUser) {
            throw new Error('No current user to invite');
        }
        this.setLoading(true);
        return services_1.Services.Department.Invite.accept(this.inviteToken)
            .then(function () { return services_1.Services.Department.updateDepartments(); })
            .then(function () {
            _this.setLoading(false);
            return _this.setInviteMethod(InviteMethod.Success);
        })
            .catch(function (e) {
            _this.setLoading(false);
            if (core_shared_1.IkeRequestErrorChecker.isValidationFailed(e)) {
                notification_service_1.NotificationService.warn({ key: index_1.T.EMAIL_EXISTS_IN_DEPARTMENT });
            }
            else {
                notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
            }
        });
    };
    AcceptInviteCtrl.prototype.inviteByNewUser = function (user) {
        var _this = this;
        this.setLoading(true);
        return Promise.resolve()
            .then(function () { return services_1.Services.User.load(user); })
            .then(function () { return _this.inviteLoggedInUser(); })
            .catch(function (e) {
            _this.setLoading(false);
            if (core_shared_1.IkeRequestErrorChecker.isValidationFailed(e)) {
                notification_service_1.NotificationService.warn({ key: index_1.T.EMAIL_INVALID });
            }
            else {
                notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
            }
        });
    };
    AcceptInviteCtrl.prototype.inviteNewSSOUser = function () {
        var _this = this;
        this.setLoading(true);
        return Promise.resolve()
            .then(function () { return services_1.Services.Department.Invite.acceptForce(_this.inviteToken); })
            .then(function () {
            _this.setLoading(false);
            _this.setInviteMethod(InviteMethod.SuccessSSO);
        })
            .catch(function (_) {
            _this.setLoading(false);
            notification_service_1.NotificationService.warn({ key: index_1.T.ERROR_GENERAL });
            _this.setInviteMethod(InviteMethod.FailedSSO);
        });
    };
    AcceptInviteCtrl.prototype.failedNewSSOUser = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            _this.setLoading(false);
            _this.setInviteMethod(InviteMethod.FailedSSO);
        });
    };
    AcceptInviteCtrl.prototype.completeSSOInvite = function () {
        var _this = this;
        this.setLoading(true);
        return services_1.Services.Department.Invite.accept(this.inviteToken)
            .then(function () { return services_1.Services.Department.updateDepartments(); })
            .then(function () { return services_1.Services.Route.go(page_1.IkePageName.root); })
            .catch(function (_) {
            _this.setLoading(false);
            notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
        });
    };
    AcceptInviteCtrl.prototype.completeInvite = function () {
        var _this = this;
        this.setLoading(true);
        return services_1.Services.Department.updateDepartments()
            .then(function () { return services_1.Services.Route.go(page_1.IkePageName.root); })
            .catch(function (e) {
            _this.setLoading(false);
            notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
        });
    };
    AcceptInviteCtrl.prototype.logout = function () {
        this.setLoading(true);
        services_1.Services.User.logout();
    };
    AcceptInviteCtrl.prototype.cancel = function () {
        services_1.Services.Route.go(page_1.IkePageName.root);
    };
    AcceptInviteCtrl.prototype.setLoading = function (loading) {
        this.loading = loading;
    };
    AcceptInviteCtrl.prototype.setTokenValidity = function (valid) {
        this.validatedToken = valid;
    };
    AcceptInviteCtrl.prototype.setAuthFailed = function (failed) {
        this.authFailed = failed;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], AcceptInviteCtrl.prototype, "awaitingCheck", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AcceptInviteCtrl.prototype, "loading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AcceptInviteCtrl.prototype, "validatedToken", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AcceptInviteCtrl.prototype, "authFailed", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], AcceptInviteCtrl.prototype, "inviteMethod", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], AcceptInviteCtrl.prototype, "setInviteMethod", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AcceptInviteCtrl.prototype, "setLoading", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AcceptInviteCtrl.prototype, "setTokenValidity", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AcceptInviteCtrl.prototype, "setAuthFailed", null);
    return AcceptInviteCtrl;
}());
exports.AcceptInviteCtrl = AcceptInviteCtrl;
//# sourceMappingURL=accept.invite.ctrl.js.map